import { render } from "./BlViewGeo.vue?vue&type=template&id=1de9ad03"
import script from "./BlViewGeo.vue?vue&type=script&lang=js"
export * from "./BlViewGeo.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/blocks/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__